import { I18n } from '@calendly/i18n';
import { FullStoryExclude } from '@calendly/ui/components/fullstory-privacy';
import { Header as CuiHeader } from '@calendly/ui/components/popup';
import { getEventTypeColorToken } from '@calendly/ui/utils/event-type-colors';
import classNames from 'classnames';
import { forwardRef } from 'react';
const markerCss = "m17vu0kt";
const Marker = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    color,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  const markerBackgroundColor = getEventTypeColorToken(color);
  const style = {
    backgroundColor: markerBackgroundColor
  };
  return <Component ref={ref} {...restProps} style={style} className={classNames(markerCss, props.className)} />;
});
const avatarLetterCss = "a7jf3mi";
const AvatarLetter = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(avatarLetterCss, props.className)} />;
});
const EventTypeNameWithColor = ({
  eventType
}) => <>
    <Marker color={eventType.color} />
    {' '}
    {eventType.name}
  </>;
const InviteeNameWithAvatar = ({
  invitee
}) => <FullStoryExclude>
    <AvatarLetter>{invitee.name[0]}</AvatarLetter>
    {' '}
    {invitee.name}
  </FullStoryExclude>;
export const Header = ({
  eventType,
  invitee,
  isInviteeOnlyReschedule
}) => <CuiHeader title={isInviteeOnlyReschedule ? I18n.t('publisher.rescheduling_flow.title_invitee') : I18n.t('publisher.rescheduling_flow.title')} subtitle={isInviteeOnlyReschedule ? <InviteeNameWithAvatar invitee={invitee} /> : <EventTypeNameWithColor eventType={eventType} />} />;

require("./popup_header.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./popup_header.js");